const weirdStringMarks = [8217, 8221];
const weirdStringMarkString = "([" + weirdStringMarks.map(code => String.fromCharCode(code)).join("") + "]|&#(" + weirdStringMarks.join("|") + ");)";
const weirdStringMarksRegexp = new RegExp(weirdStringMarkString, "g");
const shortcodeAttrRegexp = /([\w\-_]+)(?:=(?:([^"'\s]+)|"([^"]+)"|'([^']+)'))?\s+/;
export class ShortcodeStringBuilder {
    constructor(inputString) {
        this.string = String(inputString);
        this.shortcodes = (this.string.match(/\[([^\]]*)\]/g) || []).map(parseShortcodeString);
    }
    compile(data, string) {
        let result = string || this.string;
        this.shortcodes.forEach(shortcode => {
            result = result.replace(shortcode.string, shortcode.builder(data));
        });
        return result;
    }
}
export function parseShortcodeString(string) {
    let shortcode = string.substring(1, string.length - 1).trim().replace(weirdStringMarksRegexp, '"');
    const attrs = {};
    const ps = shortcode.match(/\s+/);
    if (ps && ps.index != null) {
        const attrs_str = shortcode.substring(ps.index).trim() + " ";
        shortcode = shortcode.substring(0, ps.index);
        let _match;
        let _input = attrs_str;
        while (_match = _input.match(shortcodeAttrRegexp)) {
            attrs[_match[1]] = _match.slice(2, 5).filter(v => v)[0] || true;
            _input = _match.input.substring(_match.index + _match[0].length);
        }
    }
    return {
        string,
        shortcode,
        attrs,
        builder: genBuilder(shortcode, attrs, string)
    };
}
export function genBuilder(shortcode, attrs, fallback) {
    return function (data) {
        let value = null;
        try {
            value = solveValue(shortcode, data, attrs) || null;
        }
        catch (e) {
            if (e === "invalid") {
                return fallback;
            }
        }
        value = value || attrs.default || "";
        if (!!value) {
            if (typeof attrs.prefix === "string") {
                value = attrs.prefix + value;
            }
            if (typeof attrs.suffix === "string") {
                value = value + attrs.suffix;
            }
            return `<span class='${shortcode}'>${value}</span>`;
        }
        return "";
    };
}
export function solveValue(key, client_oeuvre, attrs) {
    var _a, _b, _c, _d, _e;
    let oeuvre = ((_a = client_oeuvre === null || client_oeuvre === void 0 ? void 0 : client_oeuvre.with) === null || _a === void 0 ? void 0 : _a.oeuvre) || {};
    switch (key) {
        case "oeuvre-title":
            return oeuvre.title;
        case "completed":
            return oeuvre.completed;
        case "general-description":
            return oeuvre.description;
        case "description":
            return oeuvre.description;
        case "artist-name":
            return ((_c = (_b = client_oeuvre.with) === null || _b === void 0 ? void 0 : _b.client_artist) === null || _c === void 0 ? void 0 : _c.name) || ((_e = (_d = client_oeuvre.with) === null || _d === void 0 ? void 0 : _d.artist) === null || _e === void 0 ? void 0 : _e.name) || "";
        case "print-info": {
            const pn = parseFloat(`${oeuvre.print_number}`);
            const pc = parseFloat(`${oeuvre.print_count}`);
            if (isNaN(pn) && isNaN(pc)) {
                return "";
            }
            return `${isNaN(pn) ? "?" : pn} / ${isNaN(pc) ? "?" : pc}`;
        }
        case "print-number":
            return `${oeuvre.print_number}`;
        case "print-count":
            return `${oeuvre.print_count}`;
        case "size": {
            const unit = attrs.unit || "cm";
            if (oeuvre.depth) {
                return `${unitfySize(oeuvre.height, attrs)} &Cross; ${unitfySize(oeuvre.width, attrs)} &Cross; ${unitfySize(oeuvre.depth, attrs)} ${unit}`;
            }
            else {
                return `${unitfySize(oeuvre.height, attrs)} &Cross; ${unitfySize(oeuvre.width, attrs)} ${unit}`;
            }
        }
        case "width":
            return `${unitfySize(oeuvre.width, attrs)}`;
        case "height":
            return `${unitfySize(oeuvre.height, attrs)}`;
        case "depth":
            return unitfySize(oeuvre.depth || 0, attrs) || "";
        default:
            throw "invalid";
    }
}
export function unitfySize(value, attrs) {
    if (value === undefined || value == null) {
        return "";
    }
    if (attrs.unit === "m" && !isNaN(parseFloat(String(value)))) {
        return (parseFloat(String(value)) / 100).toFixed(2);
    }
    return String(value);
}
